export default [
	{
		title: 'Getting Started',
		url: '/docs/getting-started'
	},
	{
		title: 'SASS Utilities',
		url: '/docs/sass'
	},
	{
		title: 'JS Utilities',
		url: '/docs/js'
	},
];